<template>
  <el-container class="app">
    <el-main class="app-main">
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue